exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invest-progress-bar__container[data-v-3d348d21] {\n  background: #2C3030;\n  height: 0.2rem;\n  margin: .5rem 0;\n  width: 100%;\n}\n.invest-progress-bar__progress[data-v-3d348d21] {\n  background: #578AD6;\n  height: 100%;\n}\n.invest-progress-bar__details[data-v-3d348d21] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.invest-progress-bar__detail .invest-progress-bar__detail-value[data-v-3d348d21] {\n  color: #578AD6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d348d21","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/sales/to_delete/Sales.ProgressBar.vue
// module id = 9xzW
// module chunks = 1